import { render } from "./ProductSelectorLandingPage.vue?vue&type=template&id=20e2780b&scoped=true"
import script from "./ProductSelectorLandingPage.vue?vue&type=script&lang=js"
export * from "./ProductSelectorLandingPage.vue?vue&type=script&lang=js"

import "./ProductSelectorLandingPage.vue?vue&type=style&index=0&id=20e2780b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e2780b"]])

export default __exports__